<template>
    <v-card>
        <v-data-table
                :page.sync="page"
                :items="items"
                :headers="headers"
                hide-default-footer
        >
            <template v-slot:[`item.id`]="{ item }">
                    {{item.std_id}}
            </template>
            
            <template v-slot:[`item.name`]="{ item }">
                <!-- <v-btn text color="primary">
                    {{item.std_fname}} {{item.std_lname}}
                </v-btn> -->
                 <router-link
          class="profile-link"
          active-class="active"
          :exact="true"
          :to="{name: 'StudentProfileTP',params:{id:item.std_id}}"
        >
          <span class="table-tutor-name">{{item.std_fname}} {{item.std_lname}}</span>
          <!-- <span class="table-tutor-email">{{item.tutor_email}}</span> -->
        </router-link>
            </template>
            <template v-slot:[`item.guardian_name`]="{ item }">
                {{item.gaurdian_fname}} {{item.gaurdian_lname}}
            </template>
            <template v-slot:[`item.phone_number`]="{ item }">
                {{item.gaurdian_contactno}}
            </template>
            <template v-slot:[`item.class_name`]="{ item }">
                {{item.school_year.school_year_name}}
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <v-btn text color="#5E5EEA">{{assessment_status_formatter(item.status)}}</v-btn>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <v-btn :loading="assigning.indexOf(item.id)!==-1"  @click="showDialog(item)" elevation="1" fab small>
                    <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
            <v-spacer></v-spacer>
            <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
        </div>
          <v-dialog v-model="dialog" persistent max-width="290">
    <v-card class="text-center" style="padding: 10px 15px">
      <v-card-title class="headline d-block text-center" color="#172B4D">Are your Sure?</v-card-title>
      <v-card-text>The student will be added to joined!</v-card-text>
      <v-card-actions class="justify-space-between">
        <v-btn :loading="confirmLoading"  color="primary" dark @click="joinStudent">Confirm</v-btn>
        <v-btn color="default" @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    </v-card>
    
</template>

<script>
    import DataTableMixin from "../../mixins/dataTable";

    export default {
        name: "EnquiryTable",
        mixins: [
            DataTableMixin
        ],
        data() {
            return {
                confirmLoading: false,
                dialog: false,
                dialogItem: '',
                assigning:[],
                loading: true,
                page: 1,
                pageCount: 3,
                itemsPerPage: 10,
                headers: [
                    {text: "SRNO", sortable: true, value: "id"},
                    {text: "Name", value: "name", sortable: true},
                    {text: "Guardian Name", value: "guardian_name", sortable: true},
                    {text: "Phone Number", value: "phone_number", sortable: true},
                    {text: "Class", value: "class_name", sortable: true},
                    {text: "Assessment", value: "status", sortable: true},
                    {text: "Enquiry At", value: "creation_time", sortable: true},
                    // {text: "Action", value: "action", sortable: true}
                ],
            };
        },
        methods: {
            showDialog(item){
                this.dialog = true;
                this.dialogItem = item;
            },
            joinStudent(){
                var item = this.dialogItem;
              
                this.assigning=[...this.assigning,item.std_id]
                axios.get(apiRoutes.students.joinUrl+item.std_id).then(response=>{
                    this.dialog = false
                    this.assigning=[...this.assigning.splice(this.assigning.indexOf(item.std_id),1)]
                    this.getItems()
                })
            },
            getItems() {
                this.loading = true
                axios.get(apiRoutes.students.assessmentUrl, {
                    params: {
                        type : 'enquiry'
                    }
                }).then(response => {
                    this.formalizeTable(response.data)
                    this.loading = false
                })
            }
        },
        mounted() {
            this.getItems()
        }
    };
</script>

<style scoped>
</style>